module.exports = __webpack_public_path__ + "static/professor-prim-3a896764a43d1b80144e66ce129c9a76.png";